import { css } from '@bts-web/utils-style-engine';
import { ReactNode } from 'react';
import { ButtonBase } from '../ButtonBase/ButtonBase';
import { FilledArrowRight } from '../../svgIcons/FilledArrowRight';

export const containerStyles = css({
  border: '1px solid rgba(234, 234, 234, 1)',
  borderEndEndRadius: 'smallBottomRight',
  borderEndStartRadius: 'smallTopRight',
  borderStartStartRadius: 'smallTopLeft',
  borderStartEndRadius: 'smallBottomLeft',
  padding: 'small',
  display: 'flex',
  flexDirection: 'column',
  gap: 'medium',
  flex: 1,
  minWidth: '220px',
});

export const titleSectionStyles = css({
  display: 'flex',
  justifyContent: 'space-between',
});

export const titleStyles = css({
  display: 'flex',
  flexDirection: 'column',
  gap: 'extra_small_3',

  '& > span:first-child': {
    color: 'neutrals.text_primary',
    fontSize: 'body.medium_medium',
    fontWeight: 'body.medium_medium',
    lineHeight: 'body.medium_medium',
  },

  '& > span:last-child': {
    color: 'neutrals.text_secondary',
    fontSize: 'caption.small_light',
    fontWeight: 'caption.small_light',
    lineHeight: 'caption.small_light',
  },
});

export const btnStyles = css({
  alignItems: 'center',
  justifyContent: 'start',

  '& > span': {
    color: 'brand.text_primary',
    fontSize: 'body.medium_medium',
    fontWeight: 'body.medium_medium',
    lineHeight: 'body.medium_medium',
  },
});

interface CarouselCardProps {
  title?: string | null;
  subtitle?: string | null | false;
  icon?: ReactNode;
  action?: ReactNode;
  actionText?: string;
  onActionClick?: () => void;
  children?: ReactNode;
  'data-testid'?: string;
}

const CarouselCard = ({
  title,
  subtitle,
  icon,
  action,
  actionText,
  onActionClick,
  'data-testid': dataTestId,
}: CarouselCardProps) => {
  const renderAction = () => {
    if (action) return action;

    if (actionText) {
      return (
        <ButtonBase
          className={btnStyles}
          noPadding
          visual="ghost"
          onClick={onActionClick}
        >
          <span>{actionText}</span>
          <FilledArrowRight
            color="positive.fill_primary"
            size={16}
            data-dir="rtl"
          />
        </ButtonBase>
      );
    }

    return null;
  };

  return (
    <div className={containerStyles} data-testid={dataTestId}>
      <div className={titleSectionStyles}>
        <div className={titleStyles}>
          {title && <span>{title}</span>}
          {subtitle && <span>{subtitle}</span>}
        </div>
        {icon}
      </div>

      {renderAction()}
    </div>
  );
};

export default CarouselCard;
